"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirrorEffectHandler = exports.MirrorEffectArgs = void 0;
const __1 = require("../../..");
const CustomScript_1 = require("../../event-handlers/core/CustomScript");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class MirrorEffectArgs {
    constructor(cloneActorArgs) {
        this.cloneActorArgs = cloneActorArgs;
        this.__type = EffectType_1.EffectType.Mirror;
        this.__typeName = "Mirror";
        this.name = "Mirror";
        this.harmful = false;
    }
}
exports.MirrorEffectArgs = MirrorEffectArgs;
let MirrorEffectHandler = class MirrorEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.cloneId = container.summonCompanion(sequence, state.creatorId, state.args.cloneActorArgs);
        state.meta.attackEhId = container.registerEventHandler(state.creatorId, EventType_1.EventType.AbilityUsed, Schedule_1.Schedule.Unlimited, new CustomScript_1.CustomScriptEventHandlerArgs("Abillity_Mirror_OnAbilityUsed", {
            cloneId: state.meta.cloneId
        }));
        state.meta.killedEhId = container.registerEventHandler(state.meta.cloneId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEventHandlersEventHandlerArgs([state.meta.attackEhId]));
        state.meta.gcId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.meta.cloneId,
            duration: __1.Duration.Permanent,
            effect: new __1.GlassCannonEffectArgs(),
            supernatural: true
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        container.cancelEventHandler(state.meta.attackEhId);
        container.cancelEventHandler(state.meta.killedEhId);
        container.cancelEffect(sequence, state.meta.gcId);
        for (const summoned of container.getEffectsOfType(state.meta.cloneId, EffectType_1.EffectType.Summoned)) {
            container.cancelEffect(sequence, summoned);
        }
    }
};
MirrorEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Mirror)
], MirrorEffectHandler);
exports.MirrorEffectHandler = MirrorEffectHandler;
